import React, { useState } from "react";
import { Link } from "react-router-dom";
import register from "../../assets/img/reg.gif";
import Button from "../../components/Button";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Input from "../../components/Input";
const Register = () => {
  const [value, setValue] = useState({});
  const handleChange = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

  };
  const [showPassword, setShowPassword] = useState(false);
  return (
    <>
      <Header />
      <div className="register_page_wrapper">
        <div className="register_banner_img">
          <img src={register} width="100%" alt="register" />
        </div>
        <div style={{ backgroundColor: "#fff" }} className="register_card">
          <div className="section_title">
            <h2>Register</h2>
          </div>
          <div className="register_content">
            <form onSubmit={handleSubmit}>
              <div className="form_group">
                <Input
                  label="Name"
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  onChange={handleChange}
                  className="name_input input_field"
                  inputGroupClass="left group"
                />
                <Input
                  label="User Name"
                  type="text"
                  name="username"
                  placeholder="Enter your username"
                  onChange={handleChange}
                  className="username_input input_field"
                  inputGroupClass="left group"
                />
              </div>
              <div className="form_group" style={{ display: "inherit" }}>
                <Input
                  label="Email"
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  onChange={handleChange}
                  className="email_input input_field"
                />
              </div>
              <div className="form_group" style={{ display: "inherit" }}>
                <Input
                  label="Mobile"
                  type="mobile"
                  name="mobile"
                  placeholder="Enter your mobile"
                  onChange={handleChange}
                  className="mobile_input input_field"
                  inputGroupClass="mobile_field"
                />
              </div>
              <div className="form_group">
                <Input
                  label="Password"
                  type={`${showPassword ? "text" : "password"}`}
                  name="password"
                  placeholder="Enter your password"
                  onChange={handleChange}
                  className="input_field"
                  inputGroupClass="left group"
                />
                <Input
                  label="Confirm Password"
                  type={`${showPassword ? "text" : "password"}`}
                  name="confirm_password"
                  placeholder="Enter your confirm password"
                  onChange={handleChange}
                  className="input_field"
                  inputGroupClass="group"
                />
              </div>
              <div
                className="form-check form-check-label show_password form_group"
                style={{
                  userSelect: "none",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Input
                  type="checkbox"
                  className="form-check-input form-check-label"
                  value="showpassword"
                  id="showpassword"
                  onChange={() => setShowPassword(!showPassword)}
                />
                <label htmlFor="showpassword" className="form-check-label">
                  &nbsp;Show Password
                </label>
              </div>
              <div
                className="form-check form-check-label show_password form_group"
                style={{
                  userSelect: "none",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Input
                  type="checkbox"
                  className="form-check-input form-check-label"
                  value="termscondition"
                  id="termscondition"
                  onChange={handleChange}
                />
                <label htmlFor="termscondition" className="form-check-label">
                  &nbsp;I agree to{" "}
                  <Link to="/termsconditions" style={{ color: "#0170b9" }}>
                    Terms & Conditions
                  </Link>
                </label>
              </div>
              <Button type="submit" className="submit_btn glow neon">
                Register
              </Button>
              <div className="go_to_login">
                <p>
                  Already have an account? <Link to="/login">Login</Link>{" "}
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Register;
